/**
 * Chart.js global configuration and plugin registration
 * Import this file in main.tsx to ensure all Chart.js plugins are registered globally
 */
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  Filler,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';

// Plugin: reset zoom on double-click for any chart that has the zoom plugin
const doubleClickResetZoomPlugin = {
  id: 'doubleClickResetZoom',
  afterInit(chart: ChartJS) {
    chart.canvas.addEventListener('dblclick', () => {
      (chart as any).resetZoom?.();
    });
  },
};

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  Filler,
  zoomPlugin,
  annotationPlugin,
  doubleClickResetZoomPlugin
);

export default ChartJS;

